import {
    useVrboQueryMissingContentMutation,
    useVrboQueryPropertyComplianceMutation,
    useVrboQueryPropertyStatusCheckpointsMutation,
    useVrboQueryPropertyStatusMutation,
} from "../../../services/bClientApi";
import useVrboAction from "../useVrboAction";
import VrboActionRow from "../VrboActionRow";

export default function VrboStatusSection(props: { propertyId: string }) {
    const { propertyId } = props

    const [queryStatus] = useVrboQueryPropertyStatusMutation()
    const [queryCheckpoints] = useVrboQueryPropertyStatusCheckpointsMutation()
    const [queryMissingContent] = useVrboQueryMissingContentMutation()
    const [queryCompliance] = useVrboQueryPropertyComplianceMutation()

    const enabled = !!propertyId

    const status = useVrboAction(
        () => queryStatus(propertyId).unwrap(),
        { errorLabel: 'querying VRBO property status', enabled },
    )
    const checkpoints = useVrboAction(
        () => queryCheckpoints(propertyId).unwrap(),
        { errorLabel: 'querying VRBO property status checkpoints', enabled },
    )
    const missingContent = useVrboAction(
        () => queryMissingContent(propertyId).unwrap(),
        { errorLabel: 'querying VRBO missing content', enabled },
    )
    const compliance = useVrboAction(
        () => queryCompliance(propertyId).unwrap(),
        { errorLabel: 'querying VRBO property compliance', enabled },
    )

    return (
        <div>
            <VrboActionRow action={status} label="Property Status" busyLabel="Querying..." resultTitle="Property Status" />
            <VrboActionRow action={checkpoints} label="Status Checkpoints" busyLabel="Querying..." resultTitle="Status Checkpoints" />
            <VrboActionRow action={missingContent} label="Missing Content" busyLabel="Querying..." resultTitle="Missing Content" />
            <VrboActionRow action={compliance} label="Property Compliance" busyLabel="Querying..." resultTitle="Property Compliance" />
        </div>
    )
}
